/**
 * DevExtreme (esm/__internal/scheduler/appointments/data_provider/utils/get_raw_appointments.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const getRawAppointments = items => items.map((_ref => {
    let {
        rawAppointment: rawAppointment
    } = _ref;
    return rawAppointment
}));
